// =============================================================================
// LIGA AJUPAM — Estado del Simulacro (v6.11.72)
// =============================================================================
// Wrappers de los dos RPCs SECURITY DEFINER del onboarding lúdico.
// Migración: `20260805_v6_11_72_01_simulacro_completed_flag.sql`.
//
// Se guarda la versión del guion completado, no un booleano: ver el comentario
// de la migración. `(supabase.rpc as any)` porque los tipos generados de
// Supabase en main todavía no incluyen estos RPCs — mismo patrón que
// `services/api/regulations.ts`.

import { supabase } from './client';

/**
 * Versión del guion que completó esta persona. `null` = nunca lo hizo.
 *
 * Nunca lanza: se consulta desde el Inicio y un error de red no puede impedir
 * que se pinte el dashboard. Ante cualquier problema devuelve `null`, que en el
 * peor caso muestra la carta del simulacro a alguien que ya lo hizo — molesto,
 * pero no roto.
 */
export async function getSimulacroCompletedVersion(
  sessionToken: string,
): Promise<number | null> {
  try {
    const { data, error } = await (supabase.rpc as any)('user_get_simulacro_status', {
      p_session_token: sessionToken,
    });
    if (error) {
      console.error('[getSimulacroCompletedVersion] RPC error:', error);
      return null;
    }
    const v = (data as any)?.completed_version;
    return typeof v === 'number' ? v : null;
  } catch (err) {
    console.error('[getSimulacroCompletedVersion] failed:', err);
    return null;
  }
}

/**
 * Marca el simulacro como completado. Silencioso a propósito: si falla, la
 * persona ya hizo el simulacro igual y lo único que pasa es que la carta vuelve
 * a aparecer. Molestarla con un error acá sería peor que el problema.
 */
export async function markSimulacroCompleted(
  sessionToken: string,
  version: number,
): Promise<void> {
  try {
    const { error } = await (supabase.rpc as any)('user_complete_simulacro', {
      p_session_token: sessionToken,
      p_version: version,
    });
    if (error) console.error('[markSimulacroCompleted] RPC error:', error);
  } catch (err) {
    console.error('[markSimulacroCompleted] failed:', err);
  }
}
